<div class="settings-heading">Change Password</div>
<div>
    <form [formGroup]="passwordResetForm" (ngSubmit)="onSubmit()" novalidate>
        <div formGroupName="changePasswordRequest">
            <div>
                <div>
                    <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>Old Password</mat-label>
                        <input
                            matInput
                            formControlName="oldPassword"
                            class="change-password-text-field"
                            type="password"
                            required
                        />
                    </mat-form-field>
                </div>
                <div class="invalid-feedback" *ngIf="!oldPassword.valid">
                    {{ oldPasswordError }}
                </div>
            </div>
            <div>
                <div>
                    <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>New Password</mat-label>

                        <input
                            matInput
                            formControlName="newPassword1"
                            class="change-password-text-field"
                            type="password"
                            required
                        />
                    </mat-form-field>
                </div>
                <div class="invalid-feedback" *ngIf="!newPassword1.valid">
                    {{ newPasswordError }}
                </div>
                <div
                    *ngIf="
                        formControl.errors &&
                        newPassword1.dirty &&
                        newPassword1.touched &&
                        formControl.errors.newPasswordSameAsOld
                    "
                    class="invalid-feedback"
                >
                    Please use a different password than your old password.
                </div>
            </div>
            <div>
                <div>
                    <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>Confirm New Password</mat-label>
                        <input
                            matInput
                            formControlName="newPassword2"
                            class="change-password-text-field"
                            type="password"
                            required
                        />
                    </mat-form-field>
                </div>
                <div
                    *ngIf="
                        formControl.errors &&
                        newPassword2.dirty &&
                        newPassword2.touched &&
                        formControl.errors.notSame
                    "
                    class="invalid-feedback"
                >
                    Passwords must match.
                </div>
            </div>
        </div>
        <div>
            <button
                mat-raised-button
                class="button"
                [disabled]="passwordResetForm.pristine || !passwordResetForm.valid"
                type="submit"
            >
                SAVE CHANGES
                <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
            </button>
        </div>
    </form>
</div>
